const classPrefix = 'main-info-collagen'
const dataPrefix = 'data-main-info-collagen'
const $container = document.querySelector(`[${dataPrefix}]`)

if ($container)
{
    mainInfoCollagen();
}
export function mainInfoCollagen() {

    const accordionHeads = $container.querySelectorAll(`[${dataPrefix}-accordion-item]`);
    const accordionContents = $container.querySelectorAll(`.${classPrefix}__accordion-content`);
    const imageItems = $container.querySelectorAll(`[${dataPrefix}-image-accordion]`);

    let activeImage = null;

    const showImage = (index) => {
        imageItems.forEach(img => {
            const imgIndex = img.getAttribute(`${dataPrefix}-image-accordion`);
            if (imgIndex === index.toString()) {
                img.classList.add('is-visible');
            } else {
                img.classList.remove('is-visible');
            }
        });
    };

    // Показываем изображение 0 при загрузке
    showImage(0);

    accordionHeads.forEach((head) => {
        head.addEventListener('click', () => {
            const index = head.getAttribute(`${dataPrefix}-accordion-item`);
            const isOpen = head.classList.contains('is-active');

            // Закрываем все
            accordionHeads.forEach(h => h.classList.remove('is-active'));
            accordionContents.forEach(c => {
                c.classList.remove('is-open');
                c.style.maxHeight = null;
            });

            if (!isOpen) {
                head.classList.add('is-active');
                const content = head.parentElement.querySelector(`.${classPrefix}__accordion-content`);
                content.classList.add('is-open');
                content.style.maxHeight = content.scrollHeight + 'px';

                showImage(index);
            } else {
                showImage(0);
            }
        });
    });

}
